export function setTallestTimelineItemHeight() {
    // Select all divs with the class of 'timeline__item'
    const timelineItems = document.querySelectorAll('.timeline__item');
    
    let maxHeight = 0;
  
    // Loop through all timeline items to find the tallest one
    timelineItems.forEach(item => {
      const itemHeight = item.offsetHeight; // Get the height of each item
      if (itemHeight > maxHeight) {
        maxHeight = itemHeight; // Update maxHeight if the current item is taller
      }
    });
  
    // Set the tallest height as a CSS variable on the root element
    document.documentElement.style.setProperty('--timeline-slider-height', `${maxHeight}px`);
  }